export default __webpack_public_path__ + "static/media/gameBgMb3.92eb3531.png";